import Api from './api.service'

import Configuration from '@/configuration';
const baseURL = Configuration.value('apiFrontend')

export default {
  get() {
    return Api().get(`${baseURL}/surcharge`)
  },
  store(payload) {
    return Api().post(`${baseURL}/surcharge`, payload)
  }
}
